import Cookies from 'js-cookie';

const domain =
    window?.location?.hostname === 'localhost'
        ? 'localhost'
        : 'clinicallearninghub.com';
const learnerCookieName =
    window?.location?.hostname === 'localhost' ||
    window?.location?.hostname.includes('nonprod')
        ? 'clh-nonprod-user-logged-out'
        : 'clh-user-logged-out';

export const CookieHelper = {
    setCookie: (name = learnerCookieName, value = 'true') => {
        Cookies.set(name, value, {
            domain,
            secure: true,
            sameSite: 'None',
            path: '/',
        });
    },
    getCookie: (name = learnerCookieName) => Cookies.get(name),
    removeCookie: (name = learnerCookieName) => {
        Cookies.remove(name, { domain });
    },
};
